import { AclEntryCondition } from 'common/types/Entities';

import { _request, APIBaseResponse, APIMethod } from '../index';

const TENANTS_PATH_PREFIX = '/tenants';
const USERS_PATH_PREFIX = 'users';
const ACLS_PATH_PREFIX = 'acls';

type APIUserAclsListParams = {
    tenantId: string;
    userId: string;
};

type APIUserAclsListResponse = APIBaseResponse<Array<UserAcl>>;

export type Acl = {
    tenantId: string;
    userId: string;
    usergroupId: string;
    resourceId: string;
    accessId: string;
    licenseId?: string;
    startDate?: string;
    endDate?: string;
    conditions?: AclEntryCondition[];
    conditionsToDisplay?: string;
    productPackageId?: string;
    productPackageName?: string;
}

export type UserAcl = {
    userGroupName?: string;
    aclResourceName?: string;
    aclResourceDisplayName?: string;
    aclAccessName?: string;
    aclAccessProperties?: string;
    acl: Acl;
};

export const APIUserAclsGetList: APIMethod<APIUserAclsListParams, APIUserAclsListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}/${ACLS_PATH_PREFIX}`)
);
